Promise.all([import('embla-carousel'), import('scripts/marmalade/extensions/embla-plugins')]).then(_ref => {
  let [moduleEmbla, moduleEmblaPlugins] = _ref;
  // Define the components
  const EmblaCarousel = moduleEmbla.default;
  // Grab the plugins
  const {
    addDotBtnsAndClickHandlers,
    addPrevNextBtnsClickHandlers
  } = moduleEmblaPlugins;

  // Have our DomObserver observe the default slider class
  DomObserver.observe('.js-default-slider', blocks => {
    blocks.forEach(block => {
      // Get the wrapping parent
      const wrap = block.querySelector('.default-slider__wrap');
      // Get the slider container
      const container = block.querySelector('.default-slider__container');
      // Create a new div for the dots
      const dotsNode = document.createElement('div');
      // Create a previous button
      const prevBtn = document.createElement('button');
      // Create a next button
      const nextBtn = document.createElement('button');
      // Set up the Embla Carousel
      const embla = EmblaCarousel(container, {
        loop: true
      });

      // Set the classes for the dots, previous, and next buttons
      dotsNode.classList.add('embla-dots');
      prevBtn.classList.add('embla-button', 'embla-button--prev');
      nextBtn.classList.add('embla-button', 'embla-button--next');

      // Add the dots to the wrap
      wrap.appendChild(dotsNode);
      // Add the previous button to the container
      container.appendChild(prevBtn);
      // Add the next button to the container
      container.appendChild(nextBtn);

      // Add the dot buttons and click handlers
      addDotBtnsAndClickHandlers(embla, dotsNode);
      addPrevNextBtnsClickHandlers(embla, prevBtn, nextBtn);
    });
  });
}).catch(error => {
  // Handle any errors that occur during import
  console.error('An error occurred while loading the modules:', error);
});